export default {
  updateUrl: ({ commit }, host) => {
    if (
      host === 'localhost:8080' ||
      host === 'localhost:8081' ||
      host === 'localhost:8082'
    ) {
      commit('setAPI', 'http://localhost:9080/upstream/')
    } else if (host === 'upstreamnz-dev.web.app') {
      commit('setAPI', 'https://upstreamnz.dev.simplesoftware.nz/')
    } else if (host.substring(0, 4) === 'dev.') {
      commit('setAPI', 'https://upstreamnz.dev.simplesoftware.nz/')
    }
  },
}
